export default __webpack_public_path__ + "trainings_with_sheet.8c54212.png";